"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Show Today': 'Show Today',
            'Ok': 'Ok',
            'Past dates are disabled': 'Past dates are disabled',
            'Future dates are disabled': 'Future dates are disabled',
            'Weekend dates are disabled': 'Weekend dates are disabled',
            'Reset': 'Reset'
        }
    },
    'es': {
        'translation': {
            'Show Today': 'Mostrar hoy',
            'Ok': 'Ok',
            'Past dates are disabled': 'Las fechas pasadas están deshabilitadas',
            'Future dates are disabled': 'Las fechas futuras están deshabilitadas',
            'Weekend dates are disabled': 'Las fechas de fin de semana están deshabilitadas',
            'Reset': 'Reiniciar'
        }
    },
    'cs': {
        'translation': {
            'Show Today': 'Dnes',
            'Ok': 'OK',
            'Past dates are disabled': 'minulost zakázána',
            'Future dates are disabled': 'budoucnost zakázána',
            'Weekend dates are disabled': 'víkendy zakázány',
            'Reset': 'Reset'
        }
    },
    'zh': {
        'translation': {
            'Show Today': '今天',
            'Ok': '确认',
            'Past dates are disabled': '禁用过去日期',
            'Future dates are disabled': '禁用未来日期',
            'Weekend dates are disabled': '禁用周末日期',
            'Reset': '重置'
        }
    },
    'he': {
        'translation': {
            'Show Today': 'היום',
            'Ok': 'אישור',
            'Past dates are disabled': 'לא ניתן  לבחור תאריך קודם',
            'Future dates are disabled': 'לא ניתן  לבחור תאריך עתידי',
            'Weekend dates are disabled': 'לא ניתן לבחור תאריכים החלים בסוף השבוע',
            'Reset': 'יום, חודש, שנאיפוס'
        }
    }
};
